// 标签样式
export function getTagStyle(idx) {
  if (idx === 'edit') return 'success'
  if (idx === 'delete') return 'danger'
  const ts = '/success/warning/danger/info'.split('/')
  return ts[idx % ts.length]
}

// 获取标签
export function getLabel(val, types) {
  const t = types.find(v => v.value == val)
  if (t) {
    return t.label
  }
  return ''
}

export const getTypeLabel = getLabel

// 获取标签
export function getLabelWithType(type, types) {
  const t = types.find(v => v.type == type)
  if (t) {
    return t.label
  }
  return ''
}

// 模块展示类型
export const moduleShowTypes = [
  { label: "列表样式", value: 1 },
  { label: "社区样式", value: 2 },
  { label: "种子列表样式", value: 3 },
  { label: "瀑布流列表样式", value: 4 },
  { label: "小说样式", value: 5 },
  { label: "多专题列表样式", value: 6 },
  { label: "专题滑动列表样式", value: 7 },
]

// 开关
export const switchTypes = [
  { label: '开启', value: true },
  { label: '关闭', value: false }
]

export const boolTypes = [
  { label: '是', value: true },
  { label: '否', value: false }
]

// 帖子类型
export const newsTypes = [
  { label: "短视频", value: 1, type: 'SP' },
  { label: "图集", value: 2, type: 'COVER' },
  { label: "视频广告", value: 3, type: 'AD_SP' },
  { label: "图片广告", value: 4, type: 'AD_COVER' },
  { label: "长视频", value: 5, type: 'MOVIE' },
  { label: "黄游帖子", value: 6, type: 'ADULT_GAME' },
  { label: "种子帖子", value: 7, type: 'SEED_LINK' },
  { label: "色图帖子", value: 8, type: 'ADULT_COVER' },
]

// 0、默认
// 1、视频帖子
// 2、种子帖子
// 3、黄游帖子
// 4、色图帖子
// 5、漫画
// 6、动漫
// 7、文字小说
// 8、有声小说
// 专题类型
export const topicTypes = [
  { label: "默认", value: 0 },
  { label: "视频帖子", value: 1 },
  { label: "种子帖子", value: 2 },
  { label: "黄游帖子", value: 3 },
  { label: "色图帖子", value: 4 },
  { label: "漫画", value: 5 },
  { label: "动漫", value: 6 },
  { label: "文字小说", value: 7 },
  { label: "有声小说", value: 8 },
]

/// 视频权限
export const videoPermissionTypes = [
  { label: 'VIP会员', value: 0 },
  { label: '金币购买', value: 1 },
  { label: '免费', value: 2 },
]
/**
 * 排序类型0-正序 1-倒序
 */
export const sortTypes = [
  { label: "正序", value: 0 },
  { label: "倒序", value: 1 },
]

export const passTypes = [
  { label: '上架', value: 1 },
  { label: '下架', value: 2 }
]

/**
* 列表最大总数
*/
export const maxTotalTypes = [1000, 2000, 5000, 10000].map(v => ({ label: v.toString(), value: v }))